@use "../../../../shared/scss" as *;

@mixin shopSection() {
  .wishlist-container {
    padding-block: p-px-to-rem(16px);
    padding-inline: p-px-to-rem(16px);
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    border-radius: p-px-to-rem(12px);
    margin-block-start: p-px-to-rem(48px);
    margin-inline: 10%;

    @include pds-media-query-max("s") {
      background-color: #eeeff2;
      margin-inline: p-px-to-rem(27px);
    }

    .no-icon {
      padding-inline-start: p-px-to-rem(28px);
    }
  }
}

:host {
  display: block;
  box-sizing: border-box;

  @include shopSection();

  & .electric-ownership {
    display: grid;
    gap: $pds-spacing-fluid-small;
    margin-block: p-px-to-rem(36px) $pds-spacing-fluid-medium;
    padding-inline: calc(10% + 11px);
    isolation: isolate;

    @include pds-media-query-max("s") {
      padding-inline: p-px-to-rem(27px);
    }

    .overview-link {
      overflow: clip;
      font-size: p-px-to-rem(20px);
      border-radius: 4px;
      position: relative;
      padding-block: 2px;
      padding-inline: 11px 5px;
      inset-inline-start: -11px;
      margin-inline: auto;

      @include pds-media-query-min-max("s", "l") {
        font-size: p-px-to-rem(18px);
      }
    }
  }
}
